<template>
	<div>
		<div class="add-to-cart"  @click="addToCart">
			<a v-text="btnText" />
		</div>
		<p class="form-error" v-if="stock_error && this.variants == 1">{{ error_translation }}</p>
		<p class="form-error" v-if="stock_error && this.variants > 1">{{ error_translation_variants }}</p>
	</div>
</template>

<script>
export default {
	props: {
		slim: { type: Boolean, default: false },
		id: { type: Number, required: true },
		name: { type: String },
		designer: { type: String, required: true },
		stock: { type: Number, required: true },
		variants: {type: Number, required: false }
	},
	data() {
		return {
			loading: false,
			quantity: 1,
			stock_error: false,
			error_translation: this.$translations.cart.stock_error,
			error_translation_variants: this.$translations.cart.stock_error_variants
		};
	},
	computed: {
		btnText() {
			return this.loading
				? "Loading"
				: this.$translations.product.add_to_cart;
		},
		cart() {
			const data = this.$store.getters["cart/data"];
			return data.items;
		}
	},
	methods: {
		async addToCart() {
			this.loading = true;
			let obj = this.cart.find(o => o.id === this.id);

			if (obj && obj.quantity >= this.stock) {
				this.stock_error = true;
			} else {
				const data = {
					id: this.id,
					quantity: this.quantity,
					designer: this.designer
				};

				await this.$store.dispatch("cart/add", data);
				
			}

			this.loading = false;
		}
	}
};
</script>
